import React from "react"
import propTypes from "prop-types"
import Accordion, {
  AccordionItem,
  AccordionHeader,
  AccordionContent
} from "../../../../components/Accordion"
import Card, { Title, Description } from "../../../../components/Card"
import InfoCard, {
  InfoCardItem,
  InfoCardTitle,
  InfoCardEdit,
  InfoCardLabel
} from "../../../../components/InfoCard"
import Button from "../../../../../../components/Button"

const MyGoals = ({ goals, removeMyGoals }) => {
  return (
    <div className="row">
      <div className="col-md-8 offset-md-2">
        <Card className="card--yellow-light">
          <Title>Setting Goals</Title>
          <Description>
            Setting goals is a process and starts with careful consideration of
            what you want to achieve. You put in supports and structures to help
            along the way and then work to achieve them. Some goals may be short
            term. Others may be long term. It would be helpful to discuss and
            explore your goals with your support team, LAC and Planner.
            Remember, together is better.
          </Description>

          <Accordion allowZeroExpanded className="accordion accordion--dark">
            {goals && !!goals.goal.length && (
              <AccordionItem>
                <AccordionHeader>My Goals</AccordionHeader>

                <AccordionContent>
                  {goals.goal.map(goal => (
                    <InfoCard
                      onDelete={() => {
                        removeMyGoals(goal.id)
                      }}
                      key={`goal-${goal.id}`}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <InfoCardItem>
                            <InfoCardLabel>Goal</InfoCardLabel>
                            <InfoCardTitle>{goal.title}</InfoCardTitle>
                          </InfoCardItem>
                        </div>

                        <div className="col-md-8">
                          <InfoCardItem>
                            <InfoCardLabel>
                              Description of Benefits
                            </InfoCardLabel>
                            <InfoCardLabel>{goal.content}</InfoCardLabel>
                          </InfoCardItem>
                        </div>
                      </div>

                      <div className="info-card_btns-group">
                        <Button
                          routerLink={{ to: `/pre-plan/my-goals/${goal.id}` }}
                          className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                        >
                          Request Support
                        </Button>

                        <InfoCardEdit href={`/pre-plan/my-goals/${goal.id}`}>
                          Edit My Goals
                        </InfoCardEdit>
                      </div>
                    </InfoCard>
                  ))}
                </AccordionContent>
              </AccordionItem>
            )}
          </Accordion>
          <Button
            routerLink={{ to: "/pre-plan/my-goals" }}
            className="btn--secondary-light btn--width-lg btn--height-lg"
          >
            Edit My Goals
          </Button>
        </Card>
      </div>
    </div>
  )
}

MyGoals.propTypes = {
  removeMyGoals: propTypes.func.isRequired,
  goals: propTypes.shape({
    goal: propTypes.arrayOf(
      propTypes.shape({
        content: propTypes.string
      })
    )
  })
}

MyGoals.defaultProps = {
  goals: {
    goal: []
  }
}

export default MyGoals
